import styled from 'styled-components';
import {Link} from "@reach/router";

export default styled(Link)`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  text-decoration: none;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
  &:hover {
    background-color: #e6e6e6;
  }
`
